// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6672":"cf7326bd","8637":"882af007"}[chunkId] + ".chunk.css";
};